import request from "@/utils/http"

/**
 *
 * @param lastMessageId 上次请求结果列表最后一条消息id
 * @param read true, false, null | 已读, 未读, 所有
 * @param type
 * @param searchText
 * @param size
 * @returns {AxiosPromise<any>}
 */
export function getMessageList({
  lastMessageId = null,
  searchText = null,
  read = null,
  type = null,
  size = 10
}) {
  return request
    .post(`/message/getMessageList`, { lastMessageId, searchText, read, type, size })
    .commonDeal()
}

export function getUnreadMessageCount() {
  return request.get(`/message/getUnreadCount`).commonDeal()
}

export function deleteAllMessage() {
  return request.get(`/message/removeAll`).commonDeal()
}

export function deleteMessage(read = true) {
  return request.post(`/message/deleteMessage`, { read })
}

export function deleteOneMessage(id) {
  return request.get(`/message/deleteOne/${id}`).commonDeal()
}

export function markRead(id) {
  return request.get(`/message/markRead/${id}`).commonDeal()
}

export function markAllRead(type = null) {
  return request.get(`/message/markAllRead`, { params: { type } }).commonDeal()
}

export function getMessageGroupList(searchText = null, read = null) {
  return request.post(`/message/getMessageGroupList`, { searchText, read }).commonDeal()
}

export function changeStickyState(sticky, type) {
  return request.post(`/message/changeStickyState`, null, { params: { sticky, type } }).commonDeal()
}

export function changeMuteState(mute, type) {
  return request.post(`/message/changeMuteState`, null, { params: { mute, type } }).commonDeal()
}

export function fakeDeleteGroup(type) {
  return request.post(`/message/fakeDeleteGroup`, null, { params: { type } }).commonDeal()
}
